import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { LoggingMessageService } from './logging-message.service';
import jwt_decode from 'jwt-decode';

import moment from 'moment';
// use date-fns package instead of Moment to greatly reduce package size


@Injectable({
    providedIn: 'root'
  })
export class AuthService {
    private userEmail: string;
    private ACCESS_TOKEN_ID = environment.AccessTokenID;
    private TOKEN_EMAIL = environment.TokenEmail;
    private TOKEN_ID_EXPIRES = environment.TokenIDExpires;
    private SUBSCRIPTION_SELECTED = environment.SubscriptionSelected;
    private IS_PRODUCTION = environment.production;
    private FEDERATION_TOKEN_ID = environment.FederationTokenID;

    private _selectedSubscription: number;
    get SelectedSubscription(): number {
      if ((this._selectedSubscription === null) || (this._selectedSubscription === undefined)) {
        this._selectedSubscription = 0;
      }
      return this._selectedSubscription;
    }
    set SelectedSubscription(value: number) {
      this._selectedSubscription = value;
    }

    private _availableSubscriptions: Array<number>;
    get AvailableSubscriptions(): Array<number> {
      return this._availableSubscriptions;
    }
    set AvailableSubscriptions(value: Array<number>) {
      this._availableSubscriptions = value;
    }

    get AvailableSubscriptionsString(): string {
        return this._availableSubscriptions.join(',');
    }
    set AvailableSubscriptionsString(value: string) {
        if ((value !== null) && (value !== undefined)) {
          const parts = value.split(',');
          if (parts && parts.length > 0) {
            this._availableSubscriptions = parts.map(Number);
          }
        } 
    }

    constructor(private http: HttpClient, private logger: LoggingMessageService) {
      this.SelectedSubscription = 0;
      this.AvailableSubscriptions = [];
    }

    getAccessToken() {
        let token: any = {};
        const tokenString = sessionStorage.getItem(this.ACCESS_TOKEN_ID);
        const user = this.getTokenEmail();
        // this.logger.info('auth.service', 'getAccessToken', this.SelectedSubscription, this.AvailableSubscriptionsString, `tokenString: ${tokenString}`, '');
        if (tokenString) {
            token = JSON.parse(tokenString);
            // this.logger.info('auth.service', 'getAccessToken', this.SelectedSubscription, this.AvailableSubscriptionsString, `Returning Token: ${tokenString}`, '');
        }
        return token;
    }

    getFederationToken() {
      let token: any = {};
      const tokenString = sessionStorage.getItem(this.FEDERATION_TOKEN_ID);
      this.logger.debug('auth.service', 'getFederationToken', this.SelectedSubscription, this.AvailableSubscriptionsString, `parsing token: ${tokenString}`, '');
      if (tokenString && tokenString !== 'undefined' && tokenString !== 'null') {
        try {
            token = JSON.parse(tokenString);
        } catch (e) {
            this.logger.warn('auth.service', 'getFederationToken', this.SelectedSubscription, this.AvailableSubscriptionsString, `Error parsing federation token:: ${e.message}`, '');
            token = null;
        }
    }
      return token;
  }
  
  getAuthUserId(): number {
    const token = this.getAccessToken();
    if (!token) return 0;
  
    try {
      // If token is a string, it's a JWT token
      const tokenStr = typeof token === 'string' ? token : token.token;
      if (tokenStr) {
        const decoded = jwt_decode<any>(tokenStr);
        //console.log('SiteCoordinator App: USERauthID', decoded?.authuserid);
        return decoded?.authuserid || decoded?.authUserId || decoded?.sub || 0;
      }
    } catch (e) {
      this.logger.warn('auth.service', 'getAuthUserId', this.SelectedSubscription, this.AvailableSubscriptionsString, `error decoding token: ${e.message}`, '');
      return 0;
    }
  
    // If token is an object, try to get authUserId directly
    return token?.authuserid || 0;
  }
  
    setFederationToken(token: any) {
      const tokenString = JSON.stringify(token.Token);
      this.logger.debug('auth.service', 'setFederationToken', this.SelectedSubscription, this.AvailableSubscriptionsString, `TokenString:${tokenString}`, '');
      sessionStorage.setItem(this.FEDERATION_TOKEN_ID, tokenString);
  }
  

    getTokenEmail(): string {
      let tokenEmail: string;
      if (this.userEmail) {
        tokenEmail = this.userEmail;
      } else {
        tokenEmail = sessionStorage.getItem(this.TOKEN_EMAIL);
        this.userEmail = tokenEmail;
      }
      return tokenEmail;
    }

    logout() {
      this.logger.warn('auth.service', 'logout', 0, '', 'deleting session variables', '');
        sessionStorage.removeItem(this.ACCESS_TOKEN_ID);
        sessionStorage.removeItem(this.TOKEN_ID_EXPIRES);
        sessionStorage.removeItem(this.SUBSCRIPTION_SELECTED);
    }

    private isAccessTokenExpired(): boolean {
        const expiresAt = sessionStorage.getItem(this.TOKEN_ID_EXPIRES);
        if (expiresAt) {
            const expiryUtc = moment.utc(expiresAt, 'YYYY-MM-DD HH:mm:ss');
            const localExpiry = expiryUtc.local();
            const nowLocal = moment().local();
            const isTokenExpired = nowLocal.isAfter(localExpiry);
            if (isTokenExpired === true) {
                const now = nowLocal.format('YYYY-MM-DD HH:mm:ss');
                const exiry = localExpiry.format('YYYY-MM-DD HH:mm:ss');
                const user = this.getTokenEmail();
                this.logger.info('auth.service', 'isAccessTokenExpired', this.SelectedSubscription, this.AvailableSubscriptionsString, `IF Token Has Expired - Now: ${now}, Token Expiry: ${exiry}`, '');
            }
            return isTokenExpired;
        }
        return true;
    }

    public isUserLoggedIn(): boolean {
        if (this.IS_PRODUCTION === false) { return true; }

        const tokenHasExpired = this.isAccessTokenExpired();
        return !tokenHasExpired;
    }

}
